export default function objectToArray(object) {
    let newArray = [];

    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const element = object[key];
            newArray.push(element);
        }
    }

    return newArray;
};